import React, { useEffect, useState } from 'react';
import { AlarmClock, MessageSquareText, Navigation } from 'lucide-react';
import { getKickoffWeather, listFootballPracticeTimes } from '../lib/api';
import { directionsUrl } from '../lib/calendarLinks';
import { easternDateTime, formatKickoff } from '../lib/kickoff';
import { reminderPhase, reminderSmsHref } from '../lib/reminder';

const btn = 'inline-flex items-center justify-center gap-1.5 px-3 py-2 font-heading uppercase tracking-widest text-[10px] transition-colors';

export const GameDayReminderBanner = () => {
  const [games, setGames] = useState([]);
  const [weather, setWeather] = useState({});

  useEffect(() => {
    listFootballPracticeTimes().then((items) => setGames(items.filter((g) => !g.cancelled && reminderPhase(g)))).catch(() => setGames([]));
  }, []);

  useEffect(() => {
    games.forEach((game) => {
      if (weather[game.id] !== undefined) return;
      getKickoffWeather(game.id).then((data) => setWeather((w) => ({ ...w, [game.id]: data }))).catch(() => setWeather((w) => ({ ...w, [game.id]: null })));
    });
  }, [games, weather]);

  if (games.length === 0) return null;

  return (
    <div className="space-y-3" data-testid="game-day-reminders">
      {games.map((game) => {
        const phase = reminderPhase(game);
        const title = (game.notes || '').split('·')[0].trim() || `Patriots vs ${game.opponent || 'opponent'}`;
        return (
          <section key={game.id} data-testid={`game-day-reminder-${game.id}`} data-phase={phase} className="border-l-4 border-[#f4b400] bg-[#0a1f44] text-white px-4 py-4 sm:px-6 sm:flex sm:items-center sm:justify-between sm:gap-6">
            <div className="flex items-start gap-3 min-w-0">
              <AlarmClock className="w-6 h-6 text-[#f4b400] shrink-0 mt-0.5" aria-hidden="true" />
              <div className="min-w-0">
                <div className="font-heading uppercase tracking-[0.3em] text-[10px] text-[#f4b400]">{phase === 'today' ? 'Game Day Reminder' : 'Tomorrow is Game Day'}</div>
                <div className="font-display text-xl sm:text-2xl leading-tight mt-0.5" data-testid={`game-day-reminder-title-${game.id}`}>{title.toUpperCase()}</div>
                <div className="text-sm text-white/85 mt-1" data-testid={`game-day-reminder-times-${game.id}`}>Report {formatKickoff(easternDateTime(game.date, game.startTime))}{game.endTime ? ` · Kickoff ${formatKickoff(easternDateTime(game.date, game.endTime))}` : ''} · {game.location}</div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 mt-3 sm:mt-0 sm:shrink-0">
              <a href={directionsUrl(game.location)} target="_blank" rel="noopener noreferrer" data-testid={`game-day-reminder-directions-${game.id}`} className={`${btn} border border-white/60 text-white hover:bg-white hover:text-[#0a1f44]`}><Navigation className="w-3.5 h-3.5" /> Directions</a>
              <a href={reminderSmsHref(game, weather[game.id])} data-testid={`game-day-reminder-text-${game.id}`} className={`${btn} bg-[#c8102e] hover:bg-[#e11d34] text-white`}><MessageSquareText className="w-3.5 h-3.5" /> Text the reminder to your group</a>
            </div>
          </section>
        );
      })}
    </div>
  );
};
